export const TRANSLATIONS_EN = {
    home : {
        Excellence: `Legal planning, negotiation and implementation of complex projects`,
        We_are_an_office: `<p>Our firm specializes in planning, negotiating and implementing complex and innovative deals, primarily of corporate and public-private nature, both in Brazil and abroad. Our combination of sophisticated legal education, corporate expertise and negotiation skills is what makes us a unique practice and enables us to conceive strategic solutions to our clients.</p>
        <p>Our clients come from diverse industries, especially highly regulated ones, such as Infrastructure & Technology, Energy, Oil & Gas, Transport & Logistics, Water & Waste Management, Information Technology, Communications, and also Supplementary Pension, Financial, and Insurance industries. Our firm has a strong presence in non-regulated markets, including in the Construction, Industrial, Real Estate, and Agribusiness industries. In all these sectors, our firm serves businesses in distinct stages, from startups and growing businesses to mature businesses, as well as those undergoing reorganization processes.</p>
        <p>We are often asked to perform sophisticated, non-repetitive legal services that require trustworthiness and enviable reputation. That is why our firm has provided the benchmark for handling corporate crises, including those involving consensual solutions with government authorities or between shareholders, changes to corporate governance structures, implementation of integrity mechanisms and suggestions of regulatory changes in an array of industries.</p>
        <p>We build on our founding and senior partners’ sound academic education and previous executive experience either as officers or in-house counsels. They are fully committed to dealing with cases in a straightforward and active manner, combining deep knowledge of the purposes behind negotiations and corporate needs and conducting thorough in-depth analysis of technical and legal issues.</p>`,
        We_are_an_office_mobile: `<p>Our firm specializes in planning, negotiating and implementing complex and innovative deals, primarily of corporate and public-private nature, both in Brazil and abroad. Our combination of sophisticated legal education, corporate expertise and negotiation skills is what makes us a unique practice and enables us to conceive strategic solutions to our clients.</p>
        <p>Our clients come from diverse industries, especially highly regulated ones, such as Infrastructure & Technology, Energy, Oil & Gas, Transport & Logistics, Water & Waste Management, Information Technology, Communications, and also Supplementary Pension, Financial, and Insurance industries. Our firm has a strong presence in non-regulated markets, including in the Construction, Industrial, Real Estate, and Agribusiness industries. In all these sectors, our firm serves businesses in distinct stages, from startups and growing businesses to mature businesses, as well as those undergoing reorganization processes.</p>
        <p>We are often asked to perform sophisticated, non-repetitive legal services that require trustworthiness and enviable reputation. That is why our firm has provided the benchmark for handling corporate crises, including those involving consensual solutions with government authorities or between shareholders, changes to corporate governance structures, implementation of integrity mechanisms and suggestions of regulatory changes in an array of industries.</p>
        <p>We build on our founding and senior partners’ sound academic education and previous executive experience either as officers or in-house counsels. They are fully committed to dealing with cases in a straightforward and active manner, combining deep knowledge of the purposes behind negotiations and corporate needs and conducting thorough in-depth analysis of technical and legal issues.</p>`,
        Complex_contracts: `<p><a href="">Contratos Complexos</a></p>
        <p><a href="">Societário, M&A e Private Equity  </a></p>
        <p><a href="">Acordos de colaboração empresarial, apoio à gestão de crises e efetividade de programas de integridade (compliance) anticorrupção </a></p>
        <p><a href="">Administrativo e Regulatório</a></p>
        <p><a href="">Startups e Fintechs </a></p>`,
        Conflict_resolution: `<p><a href="">Solução de conflitos (contencioso e arbitragem)</a></p>
        <p><a href="">Previdência complementar </a></p>
        <p><a href="">Mercado Imobiliário</a></p>
        <p><a href="">Tributário</a></p>`,
        Areas_of_expertise: "PRACTICE"
    },
    footer: {
        Contact: "Contact",
        Name: "Barros Pimentel<br /> Alcantara Gil<br /> Rodriguez <br />Advogados",
        Address: `<p>Av. Presidente Juscelino Kubitscheck, 360 - 6 andar<br></br> 04543-000 São Paulo, SP - Brasil </p>
        <p className="noline"><a target='_blank' href="https://www.google.com/maps?sca_esv=fdf7728f28b59cda&rlz=1C5CHFA_enBR1119BR1119&output=search&q=Av.+Presidente+Juscelino+Kubitschek,+360+-+6+andar&source=lnms&fbs=AEQNm0Aa4sjWe7Rqy32pFwRj0UkW1DRbm01j6DCVS0r1sTxn7qyFqqwRNXgC_Y_lUOzm3nmzVSiG65fwqNbKkelFFx3JwPVeKZnuOfcEztEjjI8TrWcOYTTPFfkfpCDHi5gYqoEX8u6Orped1_PWxiD5RLtjofJmwonVQOSBngvp0Ejfevbioh1bsO--n51yu3paKMmJG4TwWSSkWNWZrN5DPI5DNqU1fA&entry=mc&ved=1t:200715&ictx=111" className="mapsgoogle">Ver no google maps</a></p>
        <p  className="noline"><a  target='_blank' href="https://www.waze.com/pt-BR/live-map/directions/br/sp/viaduto-presidente-juscelino-kubitscheck-de-oliveira?to=place.Em9WaWFkdXRvIFByZXMuIEp1c2NlbGlubyBLdWJpdHNjaGVjayBkZSBPbGl2ZWlyYSAtIFJQMSAoUmVnacO1ZXMgZGUgUGxhbmVqYW1lbnRvKSwgTWF1w6EgLSBTUCwgMDkzNzAtODAwLCBCcmF6aWwiLiosChQKEgntNnybcmnOlBHZa2PaieoUfxIUChIJOxIEa25pzpQR5EYHtZQgtvI" className="mapswaze">Ir para o Waze</a></p>`,
        Phone: "+55 11 3896.1600",
        Email: "barrospimentel@barrospimentel.adv.br",
        Linkedin: "Barros Pimentel Advogados",
        Copy: `<li><p><span className="c-primary">Barros Pimentel</span> Alcantara Gil <span className="c-primary">Rodriguez</span> Advogados</p></li>
        <li>
            <a href="#home" className="top text-uppercase c-primary" title="Back to top">Home</a>
        </li>
        <li><p className="c-primary">#BP2022</p></li>`
    },

    menu: {
        Home: `Home`,
        Who_we_are: `About Us`,
        Recognition: `Acknowledgments`,
        Performance: `Practice`,
        Professionals: `Attorneys`,
        News: `Publications`,
        Contact: `Contact`,
    },

    modal: {
        read_the_article: 'Read article',
        read_news: 'Read news',
        recognition : {
            name: "Acknowledgments",
            analysis: "Análise Advocacia",
            we_have: "We have been ranked among the most admired firms and lawyers in Brazil since 2010",
            list_1: `<h4>Practices</h4>
            <li>Banking and Finance</li>
            <li>Civil Law</li>
            <li>Commercial Contracts</li>
            <li>Compliance</li>
            <li>Corporate</li>
            <li>Infrastructure and Regulatory</li>
            <li>Mergers and Acquisitions</li>
            <li>Real Estate</li>
            <li>Tax</li>`,
            list_2: `<h4>Industries</h4>
            <li>Sugar & Ethanol</li>
            <li>Construction & Engineering</li>
            <li>Electric Power</li>
            <li>Technology</li>
            <li>Transport & Logistics</li>
            <li>Concessions and Public-Private Partnerships</li>
            <li>Environmental Services and Sanitation</li>`,
            list_3: `<h3>Análise Advocacia</h3>
            <h4>Diversity and Inclusion</h4>
            <p>Firms that make a difference</p>`,
            operation_america: 'Since 2012, Chambers has recognized our firm&#39;s advice on Projects in Latin America'
    
        },
        control: {
            previous: "previous",
            home: "home",
            next: "next",
            Home: `Home`,

            Who_we_are: `about us`,
            Recognition: `acknowledgments`,
            Performance: `practice`,
            Professionals: `attorneys`,
            News: `publications`,
            Contact: `contact`,
            articles: `publications`,
            bulletin: `newsletter`
        },
        acting: {
            title:`Practice`,
        },
        articles: {
            title:`Articles`,    
        },
        news: {
            title:`News`,
        },
        bulletin: {
            title:`Newsletter`,
            read: `read newsletter`,
        }
    }
};